import React from 'react'
import GlobalSnackbarNotifier from '../../shared/components/ui-widgets/GlobalSnackbarNotifier'
import { Box, Grid, Link } from '@mui/material'
import { WWW_BASE_URL } from '../../../App'
import ResetPasswordComponent from '../components/ResetPasswordComponent'

const ResetPasswordPage: React.FC = () => {
  return (
    <>
      <GlobalSnackbarNotifier/>
      <Grid container justifyContent={'center'} alignItems={'center'} sx={{ pt: 10 }}>
        <Grid item lg={4}>
          <Link href={WWW_BASE_URL} sx={{ display: 'block', width: '100%', textAlign: 'center' }}>
            <Box component={'img'} sx={{ width: 240 }} src='/icons/Sun-Exchange-Grey-Orange.png' alt='Sun Exchange Logo'/>
          </Link>
          <ResetPasswordComponent/>
        </Grid>
      </Grid>
    </>
  )
}

export default ResetPasswordPage
